import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { ArrowDownBlackIcon, RadiusIcon } from '../Icons';
import { Input } from '../Input';
import { EInputType } from '../Input/Content';

interface Props {
  radius: any;
  setRadius: any;
  radiusUnit: any;
  setRadiusUnit: any;
  radiusLabel: string | React.ReactNode;
  kilometersLabel: string | React.ReactNode;
  metersLabel: string | React.ReactNode;
}

export const RADIUS_UNIT_TYPE = {
  KILO_METERS: 'km',
  METERS: 'm',
};

export const RadiusInput = (props: Props) => {
  return (
    <div
      className='d-flex align-items-center radius-input'
      onClick={(e) => {
        // we need it to prevent onFocus call in the ReactTags base component
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div className='d-flex align-items-center justify-content-center'>
        <RadiusIcon className='radius-icon' />
        <div className='font-14 font-bold ps-3 pe-3'>{props.radiusLabel}</div>
      </div>
      <div className='radius-wrapper'>
        <Input
          inputType={EInputType.Text}
          type={'number'}
          min={1}
          max={props.radiusUnit === RADIUS_UNIT_TYPE.KILO_METERS ? 99 : 9999}
          value={props.radius}
          onChange={(name, value) => {
            props.setRadius(Number(value));
          }}
          inputWrapperClass='radius-input-wrapper'
          id='radiusInput'
          label='Radius Input'
        />
        <Dropdown className='download-toggle' align='end'>
          <Dropdown.Toggle className='button mt-0 basicLink svg-fill fw-bold' variant=''>
            <div className='download-toggle-content'>
              <span className='text-black'>{props.radiusUnit}</span>
              <ArrowDownBlackIcon className='arrow ms-2' />
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                props.setRadiusUnit(RADIUS_UNIT_TYPE.KILO_METERS);
              }}
            >
              <div className='text-black'>{props.kilometersLabel}</div>
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                props.setRadiusUnit(RADIUS_UNIT_TYPE.METERS);
              }}
            >
              <div className='text-black'>{props.metersLabel}</div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};
